export enum QuestionState {
  FirstBlock,
  SecondBlock,
  ThirdBlock,
  ReadOnlyView
}
